export const PHONE_AREAS = [
  {
    label: '+54',
    value: '+54',
    description: 'Argentina (阿根廷) +54',
  },
  {
    label: '+61',
    value: '+61',
    description: 'Australia (澳大利亚) +61',
  },
  {
    label: '+43',
    value: '+43',
    description: 'Austria (奥地利) +43',
  },
  {
    label: '+32',
    value: '+32',
    description: 'Belgium (比利时) +32',
  },
  {
    label: '+591',
    value: '+591',
    description: 'Bolivia (玻利维亚) +591',
  },
  {
    label: '+55',
    value: '+55',
    description: 'Brazil (巴西) +55',
  },
  {
    label: '+359',
    value: '+359',
    description: 'Bulgaria (保加利亚) +359',
  },
  {
    label: '+1',
    value: '+1',
    description: 'Canada (加拿大) +1',
  },
  {
    label: '+56',
    value: '+56',
    description: 'Chile (智利) +56',
  },
  {
    label: '+86',
    value: '+86',
    description: 'China (中国大陆) +86',
  },
  {
    label: '+852',
    value: '+852',
    description: 'Hong Kong (中国香港) +852',
  },
  {
    label: '+420',
    value: '+420',
    description: 'Czech Republic (捷克) +420',
  },
  {
    label: '+45',
    value: '+45',
    description: 'Denmark (丹麦) +45',
  },
  {
    label: '+20',
    value: '+20',
    description: 'Egypt (埃及) +20',
  },
  {
    label: '+251',
    value: '+251',
    description: 'Ethiopia (埃塞俄比亚) +251',
  },
  {
    label: '+358',
    value: '+358',
    description: 'Finland (芬兰) +358',
  },
  {
    label: '+33',
    value: '+33',
    description: 'France (法国) +33',
  },
  {
    label: '+49',
    value: '+49',
    description: 'Germany (德国) +49',
  },
  {
    label: '+91',
    value: '+91',
    description: 'India (印度) +91',
  },
  {
    label: '+62',
    value: '+62',
    description: 'Indonesia (印度尼西亚) +62',
  },
  {
    label: '+39',
    value: '+39',
    description: 'Italy (意大利) +39',
  },
  {
    label: '+81',
    value: '+81',
    description: 'Japan (日本) +81',
  },
  {
    label: '+327',
    value: '+327',
    description: 'Kazakstan (哈萨克斯坦) +327',
  },
  {
    label: '+254',
    value: '+254',
    description: 'Kenya (肯尼亚) +254',
  },
  {
    label: '+82',
    value: '+82',
    description: 'Korea (韩国) +82',
  },
  {
    label: '+52',
    value: '+52',
    description: 'Mexico (墨西哥) +52',
  },
  {
    label: '+977',
    value: '+977',
    description: 'Nepal (尼泊尔) +977',
  },
  {
    label: '+47',
    value: '+47',
    description: 'Norway (挪威) +47',
  },
  {
    label: '+63',
    value: '+63',
    description: 'Philippines (菲律宾) +63',
  },
  {
    label: '+48',
    value: '+48',
    description: 'Poland (波兰) +48',
  },
  {
    label: '+974',
    value: '+974',
    description: 'Qatar (卡塔尔) +974',
  },
  {
    label: '+40',
    value: '+40',
    description: 'Romania (罗马尼亚) +40',
  },
  {
    label: '+966',
    value: '+966',
    description: 'Saudi Arabia (沙特阿拉伯) +966',
  },
  {
    label: '+65',
    value: '+65',
    description: 'Singapore (新加坡) +65',
  },
  {
    label: '+27',
    value: '+27',
    description: 'South Africa (南非) +27',
  },
  {
    label: '+34',
    value: '+34',
    description: 'Spain (西班牙) +34',
  },
  {
    label: '+94',
    value: '+94',
    description: 'Sri Lanka (斯里兰卡) +94',
  },
  {
    label: '+46',
    value: '+46',
    description: 'Sweden (瑞典) +46',
  },
  {
    label: '+41',
    value: '+41',
    description: 'Switzerland (瑞士) +41',
  },
  {
    label: '+66',
    value: '+66',
    description: 'Thailand (泰国) +66',
  },
  {
    label: '+90',
    value: '+90',
    description: 'Turkey (土耳其) +90',
  },
  {
    label: '+44',
    value: '+44',
    description: 'United Kiongdom (英国) +44',
  },
  {
    label: '+1',
    value: '+1',
    description: 'United States of America (美国) +1',
  },
  {
    label: '+84',
    value: '+84',
    description: 'Vietnam (越南) +84',
  },
  {
    label: '+260',
    value: '+260',
    description: 'Zambia (赞比亚) +260',
  },
];
